import { render } from "./receta-layout.vue?vue&type=template&id=75bff52c&scoped=true"
import script from "./receta-layout.vue?vue&type=script&lang=js"
export * from "./receta-layout.vue?vue&type=script&lang=js"

import "./receta-layout.vue?vue&type=style&index=0&id=75bff52c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75bff52c"]])

export default __exports__